import { createClient, SupabaseClient } from "@supabase/supabase-js";
import { Database } from "./supabaseTypes";

export const SYSTEM_ORG_UUID = "00000000-0000-0000-0000-000000000000";

export type TypedSupabaseClient = SupabaseClient<Database>;

export const supabase = createClient<Database>(
  import.meta.env.VITE_SUPABASE_URL,
  import.meta.env.VITE_SUPABASE_PB_KEY,
  {
    auth: {
      experimental: { passkey: true },
    },
  },
);
